<div style="display: flex; height: 100%;">
  <div style="display: flex; overflow: hidden; width: 100%;">
    <div style="display: flex; flex-direction: column; margin: 20px; z-index: 1; overflow: hidden; width: 100%;">
      <mat-toolbar color="primary" style="place-content: center space-between; align-items: center; flex-direction: row; box-sizing: border-box; display: flex; padding: 20px;" class="toolbar-over-card">
        <!-- Title -->
        <div>Download Briefcase | Total Items: <span>{{totalEntries$ | async }}</span></div>

        <div style="display: flex; font-size: medium;">
          <button mat-icon-button [disabled]="(hasPreviousPage$ | async) === false" (click)="loadPreviousPage()"
                  matTooltip="Previous page">
            <mat-icon>chevron_left</mat-icon>
          </button>
          <button mat-icon-button [disabled]="(hasNextPage$ | async) === false" (click)="loadNextPage()"
                  matTooltip="Next page">
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
      </mat-toolbar>
      <mat-card appearance="outlined" class="card-under-toolbar" style="overflow: hidden; display: flex; height: 100%;">
        <mat-card-content class="mat-elevation-z2"
                          style="overflow: hidden; flex: auto; display: flex; flex-direction: column;">
          <div style="overflow: auto; height: 100%;">
            <table mat-table *ngIf="dataSource$ | async as dataSource" [dataSource]="dataSource" matSort class="table-width" style="width: 100%">
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef matTooltip="Download Link" style="width: 10%"></th>
                <td mat-cell *matCellDef="let element">
                  <div *ngIf="element.status === 2" style="display: flex; align-items: center; gap: 15px; cursor: pointer; padding-right: 20px;" (click)="download(element)">
                    <mat-icon>download</mat-icon>
                    <span>Download</span>
                  </div>
                  <div *ngIf="element.status < 2 || element.status === 3" style="display: flex; align-items: center; gap: 15px; padding-right: 20px;">
                    <mat-spinner [diameter]="22"></mat-spinner>
                    <span style="margin-left: 1px;">Creating</span>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="title">
                <th mat-header-cell *matHeaderCellDef matTooltip="Title" style="width: 5%">Title</th>
                <td mat-cell *matCellDef="let element" [routerLink]="['/', 'case', 'edit-briefcase', element.id]">
                  <div style="min-height: 63px; display: flex; flex-direction: column; justify-content: center; padding-right: 20px; cursor: pointer;">
                    <div style="font-weight: 400;">{{element.title}}</div>
                    <div class="comments" *ngIf="element.comments" style="margin-top: 3px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{element.comments}}</div>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="createdByEmail">
                <th mat-header-cell *matHeaderCellDef matTooltip="CreatedByEmail" style="width: 5%">Created By</th>
                <td mat-cell *matCellDef="let element">{{element.createdByEmail }}</td>
              </ng-container>
              <ng-container matColumnDef="createdAt">
                <th mat-header-cell *matHeaderCellDef matTooltip="Created At" style="width: 15%;">Created At</th>
                <td mat-cell *matCellDef="let element">{{element.createdAt | date: 'medium'}}</td>
              </ng-container>
              <ng-container matColumnDef="customDesignation">
                <th mat-header-cell *matHeaderCellDef matTooltip="Custom Designation">Custom Designation</th>
                <td mat-cell *matCellDef="let element">{{element.customDesignation }}</td>
              </ng-container>
              <ng-container matColumnDef="batesStampPages">
                <th mat-header-cell *matHeaderCellDef matTooltip="Bates Stamp Pages">Bates Stamp Pages</th>
                <td mat-cell *matCellDef="let element" >
                  <mat-icon *ngIf="element.hasBatesStampPages">check</mat-icon>
                </td>
              </ng-container>
              <ng-container matColumnDef="totalDocuments">
                <th mat-header-cell *matHeaderCellDef matTooltip="Total Documents">Total Documents</th>
                <td mat-cell *matCellDef="let element">{{element.totalDocuments }}</td>
              </ng-container>
              <ng-container matColumnDef="size" >
                <th mat-header-cell *matHeaderCellDef matTooltip="Size" style="width: 5%">Size</th>
                <td mat-cell *matCellDef="let element">{{element.size }}</td>
              </ng-container>
              <ng-container matColumnDef="remove" >
                <th mat-header-cell *matHeaderCellDef matTooltip="Size" style="width: 5%"></th>
                <td mat-cell *matCellDef="let element">
                  <div *ngIf="element.status === 2" style="display: flex; align-items: center; gap: 15px; cursor: pointer; padding-right: 20px;">
                    <mat-icon (click)="delete(element.id)">delete</mat-icon>
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
              <tr mat-row *matRowDef="let row; columns:columnsToDisplay"></tr>
            </table>
          </div>
          <div class="paging-container">
            <mat-paginator [pageSize]="200" [pageSizeOptions]="[25, 50, 100, 200]"
                           [length]="totalEntries$ | async" (page)="movePage($event)" showFirstLastButtons
                           #paginator></mat-paginator>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
